const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '全线支持1080P与4K超高清播放，每一帧都清晰锐利，让您在西瓜视频和丝瓜视频的内容中感受影院级观影体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '智能多节点分发技术，自动匹配最优线路。无论高峰时段还是热门剧集更新，都能确保流畅播放不卡顿。',
  },
  {
    icon: 'ri-money-cny-circle-line',
    title: '完全免费',
    desc: '桔子视频所有内容永久免费开放，无需注册账号、无需会员付费。打开即看，就是这么简单纯粹。',
  },
];

export default function Features() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full uppercase tracking-wide">
            平台优势
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">为什么选择桔子视频</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            三大核心优势，给你最好的观影体验。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((f) => (
            <div key={f.title} className="bg-background-100 rounded-2xl p-8 text-center border border-background-200/60 hover:border-primary-300/30 transition-all duration-200 cursor-pointer group">
              <div className="w-16 h-16 mx-auto rounded-2xl bg-primary-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
                <i className={`${f.icon} text-background-50 text-2xl`}></i>
              </div>
              <h3 className="mt-5 text-lg font-bold text-foreground-950">{f.title}</h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}